import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useQuery } from '@tanstack/react-query';

export const ASSETS_USING_METADATA_FIELD_QUERY_KEY = 'metadata.assetsUsingMetadataField';

export const useFetchAssetsUsingMetadataField = (metadataFieldId: string | undefined) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const { data, isLoading, error } = useQuery({
    queryKey: [ASSETS_USING_METADATA_FIELD_QUERY_KEY, tenantId, metadataFieldId],
    queryFn: async () => {
      const response = await api.metadata.listAssetsUsingMetadataField({
        tenantId,
        fieldId: metadataFieldId!,
        perPage: 1,
      });
      return response.data;
    },
    enabled: !!tenantId && !!metadataFieldId,
  });

  return {
    total: data?.pageData.total ?? 0,
    isLoading,
    error,
  };
};
